import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    HostBinding,
    Input,
    OnChanges,
    Output
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { createGroupControlsConfig, groupTypes } from './account-create-groups-panel.constants';
import { CreateGroupRequest, Group } from '../../../model/group/group';
import { GroupService } from '../../../data-access-layer/groups/group.service';
import { NotifService } from '../../../core/notification/notif.service';

@Component({
    selector: 'map-account-create-groups-panel',
    templateUrl: './account-create-groups-panel.component.html',
    styleUrls: ['./account-create-groups-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountCreateGroupsPanelComponent implements OnChanges {
    createGroupForm: UntypedFormGroup;
    @HostBinding('class') class = 'pagePanelCreateGroup';
    @Input() groups: Group[];
    @Input() isMoveDataPanel: boolean;
    @Input() moveParentId: number;
    @Output() created = new EventEmitter<string>();
    @Output() openPopUp = new EventEmitter<any>();
    groupType: any;
    parentGroupId: number;

    readonly ROW_GROUP = 1;
    readonly COLUMN_GROUP = 2;

    constructor(
        private readonly groupService: GroupService,
        private readonly formBuilder: UntypedFormBuilder,
        private readonly notifService: NotifService) {


    }

    ngOnChanges() {
        this.initForm();
    }

    createGroup(): void {
        if (this.isMoveDataPanel) {
            this.groupService.createGroup(this.constructCreateGroupRequest(), true).subscribe(
                group => {
                    this.created.emit('New group created, and data migrated successfully.');
                },
                error => {
                    // Error might be wrapped in a function by throwError
                    const actualError = typeof error === 'function' ? error() : error;
                    this.handleGroupError(actualError);
                }
            );
        } else {
            let parentID = this.constructCreateGroupRequest().parentID;
            this.groupService.checkIfDataExist(parentID).subscribe(dataExist => {
                if (dataExist) {
                    this.openPopUp.emit(this.createGroupForm.controls.parentID.value);
                } else {
                    this.groupService.createGroup(this.constructCreateGroupRequest(), false).subscribe(
                        group => {
                            this.creationComplete();
                        },
                        error => {
                            // Error might be wrapped in a function by throwError
                            const actualError = typeof error === 'function' ? error() : error;
                            this.handleGroupError(actualError);
                        }
                    );
                }
            });
        }

    }

    creationComplete(): void {
        this.groups = [];
        this.created.emit('Group created successfully.');
    }

    private constructCreateGroupRequest(): CreateGroupRequest {
        const request: CreateGroupRequest = {
            parentID: this.createGroupForm.controls.type.value == groupTypes.ROW_GROUP ? this.createGroupForm.controls.parentID.value : this.parentGroupId,
            name: this.createGroupForm.controls.name.value.trim(),
            type: this.createGroupForm.controls.type.value
        };
        return request;
    }

    initForm() {
        this.createGroupForm = this.formBuilder.group(createGroupControlsConfig);
        if (this.groups && this.groups.length > 0) {
            const parentGroup = this.groups.find(element => element.parentId == null);
            if (parentGroup !== undefined) {
            this.parentGroupId = parentGroup.id;
            this.createGroupForm.patchValue({ parentID: this.parentGroupId});
            }
        }
        if (this.isMoveDataPanel) {
            this.createGroupForm.patchValue({ parentID: this.moveParentId });
            this.createGroupForm.controls.parentID.disable();
        }
    }

    showParentGroup() {
        return groupTypes.ROW_GROUP == this.createGroupForm.controls.type.value;
    }

    private handleGroupError(error: any): void {
        // Error handling is done by the HTTP interceptor
        // which shows the appropriate message for duplicate group names
    }
}
